import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { LoaderService } from './loader.service';
import { FORCE_LOADER, SKIP_LOADER } from './loader.context';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // A decisão é tomada uma única vez, no início da requisição: assim um
    // `disable()`/`enable()` no meio do caminho nunca desbalanceia o contador
    // (era o que deixava o overlay preso em tela).
    if (!this.shouldShowLoader(request)) {
      return next.handle(request);
    }

    this.loaderService.push();

    return next.handle(request).pipe(finalize(() => this.loaderService.pop()));
  }

  /**
   * Ordem de precedência:
   *
   * 1. `skipLoader()` — a chamada se declara de segundo plano e nunca bloqueia.
   * 2. `disable()` — a tela suprimiu o overlay para o próprio fluxo.
   * 3. `forceLoader()` — a chamada exige o overlay mesmo fora da janela.
   * 4. Automático — só bloqueia se houver ação recente do usuário.
   *
   * O passo 4 é a rede de segurança: qualquer rotina de segundo plano que
   * apareça depois já nasce silenciosa, sem depender de alguém lembrar de
   * marcá-la.
   */
  private shouldShowLoader(request: HttpRequest<any>): boolean {
    if (request.context.get(SKIP_LOADER) || !this.loaderService.active) {
      return false;
    }

    return request.context.get(FORCE_LOADER) || this.loaderService.triggeredByUser;
  }
}
